import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    checkifbatchused (id) {
        return Api().get('smpuritem/checkifbatchused/'+id)
    },
    getprevsales (party) {
        return Api().get('smpuritem/getprevsales/'+party)
    },


    //GMW
    checkifbatchusedgmw (id) {
        return GmwApi().get('puritem/checkifbatchused/'+id)
    },
    getprevsalesgmw (party) {
        return GmwApi().get('puritem/getprevsales/'+party)
    },
}